import { apiClient } from './client';

export interface AdminUser {
    adminUserId: string;
    username: string;
    displayName: string;
    email: string | null;
    status: number;
    lastLoginAt: string | null;
}

export interface LoginResponse {
    token: string;
    permissions: string[];
    adminUser: AdminUser;
}

export interface AdminMeResponse {
    adminUser: AdminUser;
    permissions: string[];
    roles: Array<{ roleId: string; name: string }>;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/login', { username, password });
    return data;
}

export async function logout(): Promise<void> {
    await apiClient.post('/auth/logout');
}

export async function getMe(): Promise<AdminMeResponse> {
    const { data } = await apiClient.get<AdminMeResponse>('/auth/me');
    return data;
}
